import { render } from "./index.vue?vue&type=template&id=d14fc5d4&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d14fc5d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14fc5d4"]])

export default __exports__